import { createSlice } from "@reduxjs/toolkit";

    const energyMetersSlice = createSlice({
    name: "eMetersCreate",
    initialState: {
        eMeters: null,
        eMetersCreate: null,
        isFetching: false,
        error: false
    },
    reducers: {
        energyMetersStart: (state) => {
        state.isFetching = true;
        },
        energyMetersSuccess: (state, action) => {
            state.isFetching = false;
            state.eMeters = action.payload
            state.error = false;
        },
        energyMetersCreateSuccess: (state, action) => {
            state.isFetching = false;
            state.eMetersCreate = action.payload
            state.error = false;
        },
        energyMetersFailure: (state) => {
            state.eMeters = null;
            state.isFetching = false;
            state.error = true;
        },
        logoutEnergyMeters: (state) => {
            state.eMeters = null;
            state.isFetching = false;
            state.error = false;
        }
    },
    });


export const { energyMetersStart, energyMetersSuccess, energyMetersCreateSuccess, energyMetersFailure, logoutEnergyMeters } = energyMetersSlice.actions;
export default energyMetersSlice.reducer;